import React from "react";

interface DonutGaugeProps {
  size?: number;
  stroke?: number;
  percent: number;
  trackClass?: string;
  ringClass?: string;
  text?: string;
  textClass?: string;
}

const DonutGauge: React.FC<DonutGaugeProps> = ({
  size = 260,
  stroke = 26,
  percent,
  trackClass = "text-slate-200",
  ringClass = "text-emerald-500",
  text,
  textClass = "text-slate-900",
}) => {
  const p = Math.max(0, Math.min(100, percent));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - p / 100);

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="currentColor"
          className={trackClass}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="currentColor"
          className={ringClass}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
        />
      </g>
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="middle"
        className={`font-extrabold ${textClass}`}
        style={{ fontSize: Math.round(size * 0.22) }}
      >
        {text ?? `${Math.round(p)}%`}
      </text>
    </svg>
  );
};

export default DonutGauge;
